import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import hospitalServices from "../../services/hospital.services";
import { useNavigate } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa";
import LoadingBar from "../common-components/toaster/loader/loader";

const HospitalInfoCard = (props) => {
     const navigate = useNavigate()
     const [departmentsList, setDepartmentList] = useState([])
     const [Fieldval, SetFieldVal] = useState({})
     const [loading, setLoading] = useState(false)

     const handleFieldValue = (e) => {
          const name = e.target.name
          const value = e.target.value
          SetFieldVal({
               ...Fieldval,
               [name]: value
          })
     }

     useEffect(() => {
          setLoading(true)
          hospitalServices.getDepartMents().then(resp => {
               setLoading(false)
               setDepartmentList(resp.data)
          }).catch(err => {
               setLoading(false)
               console.log(err)
          })
          hospitalServices.getHospitalProfile().then(resp => SetFieldVal(resp.data)).catch(err => console.log(err))
          setLoading(false)
     }, [])


     const handleDocUpload = (e) => {
          const name = e.target.name
          const file = e.target.files[0];
          SetFieldVal({
               ...Fieldval,
               [name]: file
          })
     }


     const updateHospitalData = (e) => {
          e.preventDefault()

          setLoading(true)
          const formData = new FormData()

          for (var key in Fieldval) {
               formData.append(key, Fieldval[key]);
          }

          hospitalServices.updateHospital(formData)
               .then(resp => {

                    setLoading(false)
                    navigate('/hospital-dashboard')
               })
               .catch(err => setLoading(false))
     }



     const showDocs = (nameFile) => {
          const body = {
               type: "hsptl_profile",
               document: nameFile
          }
          setLoading(true)
          hospitalServices.getFilesData(body)
               .then(resp => {
                    setLoading(false)
                    window.open(resp.data.signedUrl, '_blank');
               })
               .catch(err => setLoading(false))

     }


     return (
          <>
               {loading && <LoadingBar />}
               <div className="sign_hdng">
                    <h2>Hospital Information</h2>
               </div>
               <Form className="signform_div" onSubmit={(e) => { updateHospitalData(e) }}>
                    <Form.Group
                         className="mb-3"
                         controlId="formBasicEmail"
                    >
                         <Form.Label>Hospital Name </Form.Label>
                         <Form.Control
                              type="text"
                              defaultValue={props.edit && Fieldval && Fieldval?.hospitalInfo?.hospital_name ? Fieldval.hospitalInfo.hospital_name : ""}
                              placeholder="Enter Hospital Name"
                              name='hospital_name'
                              onChange={(e) => { handleFieldValue(e) }}
                              required
                         />
                    </Form.Group>
                    <Form.Group
                         className="mb-3"
                         controlId="formBasicEmail"
                    >
                         <Form.Label>
                              Name of contact person from Hospital
                         </Form.Label>
                         <Form.Control
                              required
                              name='name_of_person'
                              type="text"
                              defaultValue={props.edit && Fieldval && Fieldval?.hospitalInfo?.name_of_person ? Fieldval.hospitalInfo.name_of_person : ""}
                              onChange={(e) => { handleFieldValue(e) }}
                              placeholder="Enter Name of contact person from Hospital"
                         />
                    </Form.Group>
                    {/* <Form.Group
                         controlId="formFile"
                         className="mb-3"
                    >
                         <Form.Label>
                              Name of the departments
                         </Form.Label>
                         <Form.Select aria-label="Default select example" required>
                              <option>
                                   Select Name of the departments
                              </option>
                              {departmentsList.map((val) => {
                                   return (
                                        <option value={val._id}>
                                             {val.department}
                                        </option>
                                   )
                              })}
                         </Form.Select>
                    </Form.Group> */}

                    <Form.Group
                         className="mb-3"
                         controlId="formBasicEmail"
                    >
                         <Form.Label>Phone Number</Form.Label>
                         <Form.Control
                              name='phone'
                              type="number"
                              defaultValue={props.edit && Fieldval && Fieldval?.hospitalInfo?.phone ? Fieldval.hospitalInfo.phone : ""}
                              onChange={(e) => { handleFieldValue(e) }}
                              placeholder="Enter Phone Number"
                              required
                         />
                    </Form.Group>

                    <Form.Group
                         className="mb-3"
                         controlId="exampleForm.ControlTextarea1"
                    >
                         <Form.Label>Address</Form.Label>
                         <Form.Control
                              name='address'
                              as="textarea"
                              defaultValue={props.edit && Fieldval && Fieldval?.hospitalInfo?.address ? Fieldval.hospitalInfo.address : ""}
                              onChange={(e) => { handleFieldValue(e) }}
                              rows={3}
                              required
                         />
                    </Form.Group>

                    <Form.Group
                         controlId="formFile"
                         className="mb-3"
                    >
                         <Form.Label>
                              Formal Certifications
                         </Form.Label>
                         <Form.Control
                              required
                              type="file"
                              name='certification'
                              onChange={(e) => { handleDocUpload(e) }}
                         />
                    </Form.Group>

                    {props.edit &&
                         <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlTextarea1"
                         >

                              <div className="prior_crtfcts">
                                   <ul>
                                        {Fieldval && Fieldval?.hospitalInfo?.certification.map((response, index) => {
                                             return (

                                                  <li>
                                                       <div className="file_div d-flex me-2 align-items-center">
                                                            <div className="fl_icn">
                                                                 <FaFilePdf />
                                                            </div>
                                                            <div className="fl_txt" style={{ 'cursor': "pointer" }}>
                                                                 <p onClick={() => showDocs(response)}>
                                                                      {response.slice(-13)}
                                                                 </p>

                                                            </div>
                                                       </div>
                                                  </li>
                                             )
                                        })}

                                   </ul>
                              </div>
                         </Form.Group>}

                    <Button
                         className="btn_theme w-100 mt-4"
                         type="submit"
                    >
                         Submit
                    </Button>
               </Form>
          </>
     );
};

export default HospitalInfoCard;
